import { useEffect } from 'react';
import { Modal } from '../../Modal/Modal';
import { UiContainer } from '../../../state/ui';
import { useHistory } from 'react-router-dom';
import './CustomerTypeModal.css';
import { ContentCard } from '../../ContentCard/ContentCard';
import { useTranslation } from '../../../i18n/i18n';
import { ApiActionResponse } from '../../../types';
import axios from 'axios';
import { useConfig } from '../../../config';
import { useAnalytics } from '../../../hooks/useAnalytics';
import SanitizedHtml from '../../SanitizedHtml/SanitizedHtml';

export const CustomerTypeModal = (): JSX.Element => {
	const ui = UiContainer.useContainer();
	const history = useHistory();
	const { api } = useConfig();
	const t = useTranslation().customerTypeModal;
	const { sendSelectUserTypeEvent, sendCustomerTypeModalShownEvent } = useAnalytics();

	// the modal opens once per new visitor, so this counts how many get to see the choice at all
	useEffect(() => {
		if (ui.isCustomerTypeModalOpen) sendCustomerTypeModalShownEvent();
	}, [ui.isCustomerTypeModalOpen]);

	const dismiss = (typeSelected: boolean = false) => {
		if (typeSelected !== true) {
			axios.post<ApiActionResponse>(`${api}customer-type.json`, '', {
				withCredentials: true,
			});
			sendSelectUserTypeEvent('none');
		}
		ui.showCustomerTypeModal(false);
		const { pathname, search } = history.location;
		history.replace(pathname + search, null);
	};

	const privateCustomerType = () => {
		axios.post<ApiActionResponse>(`${api}customer-type.json`, 'private', {
			withCredentials: true,
		});
		// the tag has to carry the new type before the event that reports the choice is sent
		ui.setCustomerType('private');
		sendSelectUserTypeEvent('private');
		//cookieService.write('customer-type', 'private', 365);
		ui.setPriceWithVat(true);
		dismiss(true);
	};

	const companyCustomerType = () => {
		axios.post<ApiActionResponse>(`${api}customer-type.json`, 'company', {
			withCredentials: true,
		});
		// the tag has to carry the new type before the event that reports the choice is sent
		ui.setCustomerType('company');
		sendSelectUserTypeEvent('company');
		//cookieService.write('customer-type', 'company', 365);
		ui.setPriceWithVat(false);
		dismiss(true);
	};

	return (
		<Modal className="customer-type-modal" show={ui.isCustomerTypeModalOpen} onDismiss={dismiss} toggle={dismiss}>
			<ContentCard className="content">
				<h4 className="content-title">{t.title}</h4>
				<div className="btn-container">
					<button className="btn btn--private" onClick={companyCustomerType}>
						<h3 className="btn-title">
							{t.company}
							<span className="btn-symbol">→</span>
						</h3>
						<p className="btn-description">
							<SanitizedHtml as="span" html={t.exVat} />
						</p>
					</button>
					<button className="btn btn--company" onClick={privateCustomerType}>
						<h3 className="btn-title">
							{t.private} <span className="btn-symbol">→</span>
						</h3>
						<p className="btn-description">
							<SanitizedHtml as="span" html={t.incVat} />
						</p>
					</button>
				</div>
			</ContentCard>
		</Modal>
	);
};
